export const API_REFRESH_ENDPOINT = 'v2/auth/refresh'
export const API_LOGOUT_ENDPOINT = 'v2/auth/logout'
